import { render, staticRenderFns } from "./unionOrdertList.vue?vue&type=template&id=4b523536&scoped=true"
import script from "./unionOrdertList.vue?vue&type=script&lang=js"
export * from "./unionOrdertList.vue?vue&type=script&lang=js"
import style0 from "./unionOrdertList.vue?vue&type=style&index=0&id=4b523536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b523536",
  null
  
)

export default component.exports